import { UserUpdateResponseBodySuccess } from './types';

export function isUserUpdateResponseBodySuccess(x: unknown): x is UserUpdateResponseBodySuccess {
  return typeof x === 'object'
    && x !== null
    && 'data' in x
    && isUserUpdateResponseBodyData(x.data);
}

function isUserUpdateResponseBodyData(x: unknown): x is UserUpdateResponseBodySuccess['data'] {
  return typeof x === 'object'
    && x !== null
    && 'type' in x
    && x.type === 'users'
    && 'id' in x
    && typeof x.id === 'string'
    && 'attributes' in x
    && isUserUpdateResponseBodyAttributes(x.attributes);
}

// eslint-disable-next-line complexity
function isUserUpdateResponseBodyAttributes(x: unknown): x is UserUpdateResponseBodySuccess['data']['attributes'] {
  return typeof x === 'object'
    && x !== null
    && 'idpId' in x
    && (typeof x.idpId === 'string' || x.idpId === null)
    && 'email' in x
    && typeof x.email === 'string'
    && 'name' in x
    && (typeof x.name === 'string' || x.name === null)
    && 'surname' in x
    && (typeof x.surname === 'string' || x.surname === null)
    && 'phone' in x
    && (typeof x.phone === 'string' || x.phone === null)
    && 'isMobilePhone' in x
    && typeof x.isMobilePhone === 'boolean'
    && 'gender' in x
    && (typeof x.gender === 'string' || x.gender === null)
    && 'birthdate' in x
    && (typeof x.birthdate === 'string' || x.birthdate === null);
}
